<ng-container *ngIf="appConfigService.enableUIDebuging">
  <div class="data-container">
    <button class="data-btn" (click)="onEditClick($event)">
      <jb-icon name='edit' width="30" fill='#FFFFFF' label='edit'>
      </jb-icon>
    </button>
  </div>
</ng-container>
<ng-content></ng-content>
